import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/index/index.vue')
  },
  {
    path: '/s2',
    name: 'S2',
    component: () => import('../views/s2/index.vue')
  },
  {
    path: '/s3',
    name: 'S3',
    component: () => import('../views/s3/index.vue')
  },
  {
    path: '/s4',
    name: 'S4',
    component: () => import('../views/s4/index.vue')
  },
  {
    path: '/s5',
    name: 'S5',
    component: () => import('../views/s5/index.vue')
  },
  {
    path: '/wall',
    name: 'Wall',
    component: () => import('../views/wall/index.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
